import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.eventType || initialState;

const makeSelectEventTypeFilterMenuStatus = () =>
  createSelector(selectGlobal, (eventTypeState) => eventTypeState.eventTypeFilterMenuStatus);

export { makeSelectEventTypeFilterMenuStatus };
